import React from 'react';
import PropTypes from 'prop-types';

// UI
import AppBar from '@material-ui/core/AppBar';
import PersonMenu from '@sift/skipper/components/appBar/PersonMenu';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';

function AppHeader({ person, classes, pictureUrl }) {
  const avatarHeader = person.id ? (
    <PersonMenu
      classes={{
        name: classes.name,
        root: classes.personMenuRoot,
        icon: classes.personMenuIcon,
      }}
      person={person}
      pictureUrl={pictureUrl}
    />
  ) : null;

  return (
    <AppBar classes={{ root: classes.root }} elevation={1}>
      <div className={classes.navigation}>{avatarHeader}</div>
    </AppBar>
  );
}

AppHeader.propTypes = {
  person: PropTypes.object,
  pictureUrl: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

const styles = theme => {
  return {
    root: {
      width: `calc(100% - ${theme.overrides.AppSidebar.width}px)`,
      marginLeft: theme.overrides.AppSidebar.width,
      fontSize: 18,
      display: 'flex',
      justifyContent: 'center',
      position: 'relative',
      zIndex: theme.zIndex.surface,
      background: theme.palette.common.white,
      color: '#000',
      boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
    },
    personMenuRoot: {
      minHeight: 64,
      maxHeight: 64,
      marginRight: 20,
    },
    personMenuIcon: {
      color: '#000 !important',
    },
    navigation: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    link: {
      textDecoration: 'none',
    },
    name: {
      color: '#000',
    },
  };
};

export default withStyles(styles)(AppHeader);
